import React, { JSX } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// auth imports
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
        <MsalProvider instance={msalInstance}>
            <App />
        </MsalProvider>
);
